import React, { JSX, useEffect, useState } from 'react';
import RichText from '../richtext';
import Styles from './ProductDetailsV3.module.scss';
import ToolTip from '../ToolTip/ToolTip';

const BenefitsSectionV3 = ({ content, priceCollection, sbStaticConstants }: any): JSX.Element => {
  const int_fmc = priceCollection?.int_fmc;
  const mob_fmc = priceCollection?.mob_fmc;
  const benefit_category = priceCollection?.mob_benefit_category;

  const benefitData = (option: any) => {
    return (
      <span className={Styles.optionwrapper}>
        {option?.icon && <img src={option?.icon} width={24} height={24} alt='icon' />}
        <span className={`${Styles.text} ms-2`}>
          <RichText content={option?.text} />
        </span>
      </span>
    );
  };

  return (
    <div>
      <div className={Styles.optioncontainer}>
        <div className={Styles.optionlist}>
          {content?.length > 0 && (
            <span className={Styles.optiontitle}>{sbStaticConstants?.benefits}</span>
          )}
          {(content || []).map((option: any, i: number) => {
            return option?.id == 'default' ||
              (option?.id == 'int_fmc' && int_fmc > 0 && benefit_category != 'FMC') ||
              (option?.id == 'multimob_fmc' && mob_fmc > 0 && benefit_category == 'MULTIMOBILE') ||
              (option?.id == 'combi_fmc' && mob_fmc > 0 && benefit_category == 'FMC') ? (
              <div key={i} className='d-flex justify-content-between'>
                <span>
                  {option && (
                    <span className='d-flex'>
                      {option?.text && !option?.isMMC && !option?.isMobileFMC && (
                         <>{benefitData(option)}</>
                      )}

                      {/* multimobile benefit display */}
                      {option?.text && benefit_category === 'MULTIMOBILE' && option?.isMMC && (
                         <>{benefitData(option)}</>
                      )}

                      {/* Mobile FMC benefit display */}
                      {option?.text &&
                        benefit_category === 'FMC' &&
                        option?.isMobileFMC &&
                      <>{benefitData(option)}</>}
                    </span>
                  )}
                </span>
                <span>
                  {option?.toolTip && <ToolTip content={option?.toolTip} isBenefit={true} />}
                </span>
              </div>
            ) : (
              ''
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default BenefitsSectionV3;
